const difficulty = [
  {
    key: 'Select Level',
    value: 'none',
    disabled: true
  },
  {
    key: 'Easy',
    value: 'easy'
  },
  {
    key: 'Medium',
    value: 'medium'
  },
  {
    key: 'Hard',
    value: 'hard'
  }
];

export default difficulty;
